module.exports = __webpack_public_path__ + "static/media/VRecycle.bcc95c71.md";